import './image-slider.scss';
import 'slick-carousel';
import 'magnific-popup';
export default () => {
	$( '.js-image-slider' ).slick( {
		rows: 0,
		infinite: true,
		arrows: false,
		dots: true,
	} );
	$( '.card-video a' ).magnificPopup( {
		type: 'iframe',
		mainClass: 'mfp-fade',
		removalDelay: 160,
		preloader: false,
		fixedContentPos: false,
	} );
	// Execute this if IE is detected.
	function msieversion () {
		let ua = window.navigator.userAgent;
		let msie = ua.indexOf( 'MSIE ' );

		if ( msie > 0 || !!navigator.userAgent.match( /Trident.*rv:11./ ) ) {
			// If ( ! Modernizr.objectfit ) {
			$( '.image' ).each( function () {
				let $container = $( this );
				let imgUrl = $container.find( 'image' ).prop( 'src' );

				if ( imgUrl ) {
					$container
						.css( 'backgroundImage', `url(${imgUrl})` )
						.addClass( 'compat-object-fit' );
				}
			} );
			// }
		}

		return false;
	} // End
	$( document ).ready( msieversion );
};
